'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import { FeatherMoreVertical } from '@subframe/core';
import { DropdownMenu } from '../DropdownMenu';
import { IconButton } from '../IconButton';
import { Table } from '../Table';
import type { RowAction } from './types';
interface DataTableRowActionsProps<T> {
  row: T;
  actions: RowAction<T>[];
  cellPaddingX?: string;
  ariaLabel?: string;
  defaultOpen?: boolean;
}
export function DataTableRowActions(t0) {
  const $ = _c(54);
  const {
    row,
    actions,
    cellPaddingX: t1,
    ariaLabel: t2,
    defaultOpen: t3
  } = t0;
  const cellPaddingX = t1 === undefined ? "px-6" : t1;
  const ariaLabel = t2 === undefined ? "A\xE7\xF5es da linha" : t2;
  const defaultOpen = t3 === undefined ? false : t3;
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== actions || $[1] !== ariaLabel || $[2] !== cellPaddingX || $[3] !== defaultOpen || $[4] !== row) {
    t14 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t15;
      if ($[21] !== row) {
        t15 = action => !action.hidden?.(row);
        $[21] = row;
        $[22] = t15;
      } else {
        t15 = $[22];
      }
      const visibleActions = actions.filter(t15);
      if (visibleActions.length === 0) {
        const t16 = `min-h-[67px] py-3 ${cellPaddingX}`;
        let t17;
        if ($[23] !== t16) {
          t17 = <Table.Cell className={t16} />;
          $[23] = t16;
          $[24] = t17;
        } else {
          t17 = $[24];
        }
        t14 = t17;
        break bb0;
      }
      T4 = Table.Cell;
      t12 = `min-h-[67px] justify-end py-3 ${cellPaddingX}`;
      t13 = _temp;
      T3 = SubframeCore.DropdownMenu.Root;
      t10 = defaultOpen;
      let t16;
      if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = <FeatherMoreVertical />;
        $[25] = t16;
      } else {
        t16 = $[25];
      }
      if ($[26] !== ariaLabel) {
        t11 = <SubframeCore.DropdownMenu.Trigger asChild={true}><IconButton variant="neutral-tertiary" icon={t16} size="small" aria-label={ariaLabel} /></SubframeCore.DropdownMenu.Trigger>;
        $[26] = ariaLabel;
        $[27] = t11;
      } else {
        t11 = $[27];
      }
      T2 = SubframeCore.DropdownMenu.Portal;
      T1 = SubframeCore.DropdownMenu.Content;
      t5 = "bottom";
      t6 = "end";
      t7 = 8;
      t8 = true;
      t9 = "animate-fade-in";
      T0 = DropdownMenu;
      let t17;
      if ($[28] !== row) {
        t17 = action_0 => <React.Fragment key={action_0.id}>{action_0.dividerBefore && <DropdownMenu.DropdownDivider />}<DropdownMenu.DropdownItem icon={action_0.icon} onClick={() => action_0.onClick(row)} disabled={action_0.disabled?.(row)} className={action_0.className}>{typeof action_0.label === "function" ? action_0.label(row) : action_0.label}</DropdownMenu.DropdownItem></React.Fragment>;
        $[28] = row;
        $[29] = t17;
      } else {
        t17 = $[29];
      }
      t4 = visibleActions.map(t17);
    }
    $[0] = actions;
    $[1] = ariaLabel;
    $[2] = cellPaddingX;
    $[3] = defaultOpen;
    $[4] = row;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = T3;
    $[9] = T4;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    T3 = $[8];
    T4 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  if (t14 !== Symbol.for("react.early_return_sentinel")) {
    return t14;
  }
  let t15;
  if ($[30] !== T0 || $[31] !== t4) {
    t15 = <T0>{t4}</T0>;
    $[30] = T0;
    $[31] = t4;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== T1 || $[34] !== t15 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t16 = <T1 side={t5} align={t6} sideOffset={t7} asChild={t8} className={t9}>{t15}</T1>;
    $[33] = T1;
    $[34] = t15;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== T2 || $[42] !== t16) {
    t17 = <T2>{t16}</T2>;
    $[41] = T2;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== T3 || $[45] !== t10 || $[46] !== t11 || $[47] !== t17) {
    t18 = <T3 defaultOpen={t10}>{t11}{t17}</T3>;
    $[44] = T3;
    $[45] = t10;
    $[46] = t11;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== T4 || $[50] !== t12 || $[51] !== t13 || $[52] !== t18) {
    t19 = <T4 className={t12} onClick={t13}>{t18}</T4>;
    $[49] = T4;
    $[50] = t12;
    $[51] = t13;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
}
function _temp(e) {
  return e.stopPropagation();
}